/* Cart drawer upsells (V16, 07.10.2026): quick-add + Platzierung von Versandbalken/Upsell-Block. */
(function () {
  if (window.__cartUpsellsBound) return;
  window.__cartUpsellsBound = true;

  function root() {
    var r = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return r.replace(/\/$/, '');
  }

  // Versandbalken unter die Kopfzeile, Upsells unter das Gewaehrleistungslabel verschieben
  function place() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var bar = drawer.querySelector('.drawer__footer .pcf');
    var header = drawer.querySelector('.drawer__header');
    if (bar && header) header.insertAdjacentElement('afterend', bar);
    var ups = drawer.querySelector('.drawer__footer .pcu');
    var label = drawer.querySelector('#CartDrawer-CartItems .cart__legal-label');
    if (ups && label) label.insertAdjacentElement('afterend', ups);
    drawer.querySelectorAll('.drawer__header ~ .pcf').forEach(function (el, i) { if (i > 0) el.remove(); });
    // Dawn ersetzt nach dem Hinzufuegen nur cart-drawer-items + .cart-drawer__footer -> der Upsell-Block ging verloren (Fix 07.10.2026)
    var items = drawer.querySelector('cart-drawer-items');
    if (!drawer.querySelector('.pcu') && label && items && !checked.has(items)) {
      checked.add(items);
      fetch(root() + '/?section_id=cart-drawer', { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (h) {
          var p = new DOMParser().parseFromString(h, 'text/html').querySelector('.pcu');
          var l = drawer.querySelector('#CartDrawer-CartItems .cart__legal-label');
          if (p && l && !drawer.querySelector('.pcu')) l.insertAdjacentElement('afterend', document.importNode(p, true));
        })
        .catch(function () {});
    }
  }
  var checked = window.WeakSet ? new WeakSet() : { has: function () { return true; }, add: function () {} };
  // setTimeout statt requestAnimationFrame: rAF pausiert in Hintergrund-Tabs und blieb dann haengen (Fix 07.10.2026)
  var busy = false;
  function schedule() { if (busy) return; busy = true; setTimeout(function () { busy = false; place(); }, 0); }
  function hook() {
    var C = window.customElements && customElements.get('cart-drawer');
    if (!C || C.prototype.__pcuHooked) return;
    C.prototype.__pcuHooked = true;
    ['renderContents', 'open'].forEach(function (m) {
      var o = C.prototype[m];
      if (typeof o !== 'function') return;
      C.prototype[m] = function () { var r = o.apply(this, arguments); place(); setTimeout(place, 0); setTimeout(place, 150); return r; };
    });
  }
  function observe() {
    place();
    hook();
    if (window.customElements && customElements.whenDefined) customElements.whenDefined('cart-drawer').then(hook);
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
    document.addEventListener('visibilitychange', place);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe); else observe();

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-upsell-prev], [data-upsell-next]');
    if (arrow) {
      var wrap = arrow.closest('.cart-upsells, .pcu');
      var slider = wrap && wrap.querySelector('[data-upsell-slider]');
      if (slider) {
        var dir = arrow.hasAttribute('data-upsell-next') ? 1 : -1;
        slider.scrollBy({ left: dir * slider.clientWidth * 0.85, behavior: 'smooth' });
      }
      return;
    }

    var btn = e.target.closest('.cart-upsell__add');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var id = btn.getAttribute('data-variant-id');
    if (!id) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    fetch(root() + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var drawer = document.querySelector('cart-drawer');
        if (json.status) {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          return;
        }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(json);
          schedule();
        } else {
          window.location.href = root() + '/cart';
        }
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  });
})();
